import { customerRoutes, requiresInsuranceInfo } from 'noddi-util';
import { useBookingSelectedSalesItemsCars } from 'noddi-web';
import { useNavigate } from 'react-router-dom';

// if extra info is required, we first navigate to the insurance info step
// If not we can navigate to confirmation step
export const useNavigateToSummaryOrRequiredInfo = () => {
  const salesItemsCars = useBookingSelectedSalesItemsCars();

  const navigate = useNavigate();

  function navigateToConfirmationOrRequiredInfo() {
    const needsInsuranceInfo = requiresInsuranceInfo(salesItemsCars);

    if (needsInsuranceInfo) {
      navigate(customerRoutes.newBookingInsuranceInfo.getPath());
    } else {
      navigate(customerRoutes.newBookingSummary.getPath());
    }
  }

  return navigateToConfirmationOrRequiredInfo;
};
